import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CancelInboundDeliveryMutation } from "../../../graphql/deliveryService/mutations/cancelInboundDelivery";
import { SuccessOutputFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface CancelInboundDeliveryMutationProps {
  dataAction?: (data: SuccessOutputFragment) => void;
  errorAction?: () => void;
}

const useCancelInboundDeliveryMutation = (
  props: CancelInboundDeliveryMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(CancelInboundDeliveryMutation, {
    update: (cache) => {
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const successFragment = data?.cancelInboundDelivery.successOutput;

  useEffect(() => {
    if (!error) return;

    handleError(t("cancelInboundDeliveryError"), t(error.message), errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !successFragment) return;

    dataAction && dataAction(successFragment);
  }, [data]);

  return mutation;
};

export default useCancelInboundDeliveryMutation;
